import { ReactElement, useEffect, useState } from 'react'
import { Select, Row, Col, Space } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'

const { Option } = Select

type Props = {
    multiple?: boolean,
    disabled?: boolean
    valueProp?: string,
    showSearch?: boolean,
    value?: string | undefined | string[]
    onChange?: (e: any) => void
    placeholder?: string
    width?: number
}

// 门店
export function SelectStores(props: Props) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/store_list').then((res: any) => {
            if (res) { setOptionData(res) }
        })
    }, [])

    let Options: ReactElement[] = optionData.map((el: any) => (<Option value={el.store_id} key={el.store_id}>{el.store_name}</Option>))

    return (
        <Select
            mode={props.multiple ? "multiple" : undefined}
            virtual={false}
            disabled={props.disabled}
            allowClear
            style={{ width: props.width ? props.width : 140 }}
            placeholder={props.placeholder ? props.placeholder : "门店"}
            onChange={props.onChange} value={props.value}
            filterOption={props.showSearch ? (input, option) => (option!.children as unknown as string).includes(input) : false}
        >
            {Options}
        </Select>)
}


// 门店销售
export function SelectSales(props: Props) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/store_employee_list', {
            params: {
                position_number: 3
            }

        }).then((res: any) => {
            setOptionData(res)
        })

    }, [])

    let Options: ReactElement[];

    Options = optionData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))

    return (<Select virtual={false} disabled={props.disabled} style={{ width: 140 }} placeholder="销售" onChange={props.onChange} value={props.value}>
        {Options}
    </Select>)
}

// 员工
interface Staffs {
    valueProp?: string,
    value?: string | undefined
    onChange?: (e: string) => void
    type: number
}

export function SelectStaffs(props: Staffs) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        // user_name：员工姓名、position_number：职位编号  0超级管理员 1客服 2员工姓名 3门店销售 4产康顾问 5产康师 6门店店长
        baseAxiosNoInfo('/employee/select_employee_list', {
            params: {
                position_number: props.type,
                user_name: ''
            }

        }).then((res: any) => {
            if (res) setOptionData(res)
        })
    }, [])

    let Options = optionData.map((el: any) => (<Option value={el.user_name} key={el.user_name}>{el.user_name}</Option>))

    return (
        <Select style={{ width: 140 }} placeholder="" onChange={props.onChange} value={props.value}>
            {Options}
        </Select>)
}

// 产康项目分类
export function SelectSingleProjectTypes(props: Props) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/chankang_center/item_type/select_list').then((res: any) => {
            if (res) setOptionData(res)
        })
    }, [])

    let Options = optionData.map((el: any) => (<Option value={el.item_type_id} key={el.item_type_id}>{el.item_type_name}</Option>))

    return (
        <Select style={{ width: 140 }} placeholder="项目分类" onChange={props.onChange} value={props.value} >
            {Options}
        </Select>)
}

// 产康项目分类
interface SingleProject {
    value?: string
    onChange?: (value: string) => void
}

export function SelectSingleProjectType(props: SingleProject) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/chankang_center/item_type/select_list').then((res: any) => {
            if (res) setOptionData(res)
        })
    }, [])

    let Options = optionData.map((el: any) => (<Option value={el.item_type_id} key={el.item_type_id}>{el.item_type_name}</Option>))

    return (
        <Select style={{ width: 140 }} placeholder="项目分类" onChange={props.onChange} value={props.value} >
            {Options}
        </Select>)
}

// 收款项目
export function SelectPayItem(props: Props) {

    const [optionData, setOptionData] = useState<{}[]>([])

    useEffect(() => {
        setOptionData([
            {
                "id": "1",
                "name": "合同全款"
            },
            {
                "id": "2",
                "name": "合同首付"
            },
            {
                "id": "3",
                "name": "一对一陪护"
            },
            {
                "id": "4",
                "name": "合同尾款"
            },
            {
                "id": "5",
                "name": "医院陪护"
            },
            {
                "id": "6",
                "name": "月嫂到家"
            },
            {
                "id": "7",
                "name": "续住收款"
            },
            {
                "id": "8",
                "name": "其他"
            },
            {
                "id": "9",
                "name": "月子餐"
            },
            {
                "id": "10",
                "name": "入住押金"
            },
            {
                "id": "11",
                "name": "套餐升级"
            },
            {
                "id": "12",
                "name": "诚意金"
            }
        ])
    }, [])

    let Options: ReactElement[] = optionData.map((el: any) => (<Option value={el.id} key={el.id}>{el.name}</Option>))

    return (
        <Select
            mode={props.multiple ? "multiple" : undefined}
            virtual={false}
            disabled={props.disabled}
            allowClear
            style={{ width: props.width ? props.width : 140 }}
            placeholder={props.placeholder ? props.placeholder : "收款项目"}
            onChange={props.onChange} value={props.value}
            filterOption={props.showSearch ? (input, option) => (option!.children as unknown as string).includes(input) : false}
        >
            {Options}
        </Select>)
}